import { Info } from "@components";
import * as RadixSwitch from "@radix-ui/react-switch";
import classNames from "classnames";
import { useState } from "react";

import Label from "../_shared/label";

interface SwitchProps {
  name: string;
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
  required?: boolean;
  info?: string;
  error?: string;
  label?: string;
  description?: string;
  between?: boolean;
  disabled?: boolean;
}

export function Switch({
  name,
  checked,
  label,
  info,
  error,
  required,
  onCheckedChange,
  description,
  between,
  disabled,
}: SwitchProps) {
  const [displayInfo, setDisplayInfo] = useState(false);
  const value = checked ? "on" : "off";

  const toggle = (
    <RadixSwitch.Root
      id={name}
      name={name}
      value={value}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={classNames(
        "relative hit-target w-10 h-6 shrink-0 rounded-full p-1 focus:ring-2 focus:ring-focus",
        {
          "cursor-not-allowed bg-raised data-[state=checked]:bg-tint": disabled,
          "cursor-pointer bg-tint data-[state=checked]:bg-primary": !disabled,
          "my-[12px]": !between,
        },
      )}
    >
      <RadixSwitch.Thumb className="w-4 h-4 bg-page rounded-full block data-[state=checked]:translate-x-4 transition-transform" />
    </RadixSwitch.Root>
  );

  const labelBlock = (label || description) && (
    <div className="flex flex-col">
      {!!label && (
        <Label
          name={name}
          label={label}
          info={info}
          error={error}
          required={required}
          displayInfo={displayInfo}
          infoId={`${name}-info`}
          setDisplayInfo={setDisplayInfo}
        />
      )}
      {!!description && (
        <p className="text-xs text-muted font-comfortaa">{description}</p>
      )}
    </div>
  );

  return (
    <fieldset className="flex flex-col">
      <div
        className={classNames(
          between
            ? "flex flex-row items-center justify-between gap-4"
            : "flex flex-col",
        )}
      >
        {labelBlock}
        {toggle}
      </div>
      <p className="text-xs ml-1 mt-1 text-danger font-comfortaa">{error}</p>
      <Info id={`${name}-info`} info={info} displayInfo={displayInfo} />
    </fieldset>
  );
}
